import React, { useCallback } from "react";
import { Redirect } from "react-router-dom";
import ProtectedRoute from "components/Auth/ProtectedRoute";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import useComplianceAccess from "hooks/useComplianceAccess";

const ComplianceProtectedRoute = ({ component: Component, ...routeProps }) => {
  const { canAccessCompliance, isAccessLoading } = useComplianceAccess();

  const Guard = useCallback(
    (props) => {
      if (isAccessLoading) {
        return (
          <div className="flex min-h-[200px] items-center justify-center">
            <SpinnerIcon className="h-6 w-6 text-sflPrimary" />
          </div>
        );
      }

      if (!canAccessCompliance) {
        return <Redirect to="/access-denied" />;
      }

      return <Component {...props} />;
    },
    [Component, canAccessCompliance, isAccessLoading]
  );

  return <ProtectedRoute {...routeProps} component={Guard} />;
};

export default ComplianceProtectedRoute;
